<template>
  <el-card id="dataStats">
    <template #header>
      <h4>{{ $t('数据统计') }}</h4>
    </template>

    <div class="content">

      <div class="row">
        <div class="row-header grid6">
          <span>{{ $t('关注数') }}</span>
          <span>{{ $t('粉丝数') }}</span>
          <span>{{ $t('获赞数') }}</span>
          <span>{{ $t('发布动态数') }}</span>
          <span>{{ $t('动态评论数') }}</span>
        </div>

        <div class="row-body grid6">
          <span class="red-color">{{userDetail.focusCount || 0}}</span>
          <span class="red-color">{{userDetail.fanCount || 0}}</span>
          <span>{{ userDetail.fanCount || 0 }}</span>
          <span>{{ userDetail.dynamicsCount || 0 }}</span>
          <span>{{ userDetail.dynamicsCommentCount || 0 }}</span>
        </div>
      </div>


      <div class="row">
        <div class="row-header grid6">
          <span>{{ $t('发布菜谱数') }}</span>
          <span>{{ $t('上架菜谱数') }}</span>
          <span>{{ $t('仓库菜谱数') }}</span>
          <span>{{ $t('审核中菜谱数') }}</span>
          <span>{{ $t('销售菜谱数') }}</span>
          <span>{{ $t('收获打赏数') }}</span>
        </div>

        <div class="row-body grid6">
          <span>{{ userDetail.releaseCount || 0 }}</span>
          <span>{{ userDetail.upCount || 0 }}</span>
          <span>{{ userDetail.draftCount || 0 }}</span>
          <span>{{ userDetail.auditCount || 0 }}</span>
          <span>{{ userDetail.sellCount || 0 }}</span>
          <span>{{ userDetail.getRewardCount || 0 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="row-header grid6">
          <span>{{ $t('菜谱使用收入') }}</span>
          <span>{{ $t('菜谱打赏收入') }}</span>
          <span>{{ $t('菜谱总收入') }}</span>
          <span>{{ $t('账号余额') }}</span>
        </div>

        <div class="row-body grid6">
          <span>{{ userDetail.payInPrice || 0 }}</span>
          <span>{{ userDetail.rewardInPrice || 0 }}</span>
          <span>{{ userDetail.addInPrice || 0 }}</span>
          <span>{{ userDetail.balance ? userDetail.balance.toFixed(2) : 0 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="row-header grid6">
          <span>{{ $t('浏览菜谱数') }}</span>
          <span>{{ $t('收藏菜谱数') }}</span>
          <span>{{ $t('使用菜谱数') }}</span>
          <span>{{ $t('评价菜谱数') }}</span>
          <span>{{ $t('购买菜谱数') }}</span>
          <span>{{ $t('打赏菜谱数') }}</span>
        </div>

        <div class="row-body grid6">
          <span>{{ userDetail.watchCount || 0 }}</span>
          <span>{{ userDetail.collectCount || 0 }}</span>
          <span>{{ userDetail.useCount || 0 }}</span>
          <span>{{ userDetail.commentCount || 0 }}</span>
          <span>{{ userDetail.buyCount || 0 }}</span>
          <span>{{ userDetail.rewardCount || 0 }}</span>
        </div>
      </div>

      <div class="row">
        <div class="row-header grid6">
          <span>{{ $t('煮饭模式使用次数') }}</span>
          <span>{{ $t('营养管理使用次数') }}</span>
          <span>{{ $t('菜谱对比使用次数') }}</span>
          <span>{{ $t('食物对比使用次数') }}</span>
          <span>{{ $t('体重计划使用次数') }}</span>
        </div>

        <div class="row-body grid6">
          <span>{{userDetail.riceCount || 0}}</span>
          <span>{{userDetail.nutritionCount || 0}}</span>
          <span>{{userDetail.cbBattleCount || 0}}</span>
          <span>{{userDetail.foodBattleCount || 0}}</span>
          <span>{{userDetail.weightPlanCount || 0}}</span>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "DataStats",
  data() {
    return {
      isLoad: false,
    }
  },
  computed: {
    userDetail() {
      return this.$store.state.userDetail;
    }
  }
}
</script>

<style scoped>

.content {
  border: 1px solid #DCDFE6;
}

.row-header,
.row-body {
  height: 50px;
}

.row-header{
  background: #f2f2f2;
  font-size: 16px;
  font-weight: bold;
}

.row-body {
  font-size: 14px;
}

.grid6 {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  place-items: center;
}

.red-color {
  color: #b93345;
}

</style>
